import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import type * as v from 'valibot';
import { COLORS_MAP } from '../../constants';
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import { ALIGN_Y_MAP } from './constants';
import type { columnsSCSchema } from './schema';
import type { Spacing, SpacingToken } from './types';
export type ColumnsProps = StructuredContentDocumentWithRenderer<v.InferInput<typeof columnsSCSchema>>;
export const Columns = t0 => {
  const $ = _c(19);
  const {
    props
  } = t0;
  const {
    alignY,
    backgroundColor,
    children,
    collapse: t1,
    padding,
    spacing: t2
  } = props;
  const collapse = t1 === undefined ? false : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {
      mobile: 3,
      desktop: "3-half"
    } : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const spacing = t3;
  const isSpacingObject = _temp;
  const gapDesktop = isSpacingObject(spacing) ? isNaN(Number(spacing.desktop)) ? spacing.desktop : Number(spacing.desktop) : spacing;
  const gapMobile = isSpacingObject(spacing) ? isNaN(Number(spacing.mobile)) ? spacing.mobile : Number(spacing.mobile) : spacing;
  const t4 = alignY ? ALIGN_Y_MAP[alignY] : undefined;
  const t5 = padding || 0;
  const t6 = COLORS_MAP[backgroundColor || "transparent"];
  const t7 = collapse ? "minmax(0, 1fr)" : "repeat(12, minmax(0, 1fr))";
  let t8;
  if ($[2] !== t7) {
    t8 = {
      xs: t7,
      sm: "repeat(12, minmax(0, 1fr))"
    };
    $[2] = t7;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== gapDesktop || $[5] !== gapMobile) {
    t9 = {
      xs: gapMobile,
      sm: gapDesktop
    };
    $[4] = gapDesktop;
    $[5] = gapMobile;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6 || $[10] !== t8 || $[11] !== t9) {
    t10 = {
      alignItems: t4,
      display: "grid",
      padding: t5,
      bgcolor: t6,
      gridTemplateColumns: t8,
      gap: t9
    };
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== children || $[14] !== collapse) {
    t11 = renderStructuredContent(children, undefined, {
      Column: {
        collapse
      }
    });
    $[13] = children;
    $[14] = collapse;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t11) {
    t12 = <Box sx={t10}>{t11}</Box>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
};
function _temp(spacing_0) {
  return typeof spacing_0 === "object" && spacing_0?.desktop !== undefined;
}